module.exports = __webpack_public_path__ + "static/media/milad-1.6da20419.JPG";